import React from "react";
import Flex from "Trackalyze/Flex";

import Typo from "Trackalyze/Typo";
import { useTranslation } from "react-i18next";
import FilterGroupsContent from "./FilterGroupsContent";
import { ListItem } from "Trackalyze/List";

const FilterGroups = ({ standalone }) => {
  const { t } = useTranslation();

  return standalone ? (
    <FilterGroupsContent standalone={standalone} />
  ) : (
    <ListItem>
      <Flex vertical spacing="3" padding="s">
        <Flex spacing="3" out itemscenter>
          <Typo type="label" size="l">
            {t("trackManager.filterOptionsGroups")}
          </Typo>
        </Flex>
        <FilterGroupsContent standalone={standalone} />
      </Flex>
    </ListItem>
  );
};

export default React.memo(FilterGroups);
